<template>
  <!-- <div class="notifications-list" @click.stop> -->
  <ul class="notifications-list dropdown-menu"> <!-- @click.stop> -->
    <li v-if="areAnyUnread" class="text-center my-0">
      <a class="notifications-list-link" href="#" @click="markAllRead">{{ txtOptions.mark_read }}</a>
    </li>
    <li>
      <div class="notification">{{ notificationMessage }}</div>
    </li>
    <li v-for="(notification, index) in notifications.slice(0, 10)" :key="index">
      <div class="mytext notification" :class="{ '_bold': !notification.is_read, '_read': notification.is_read }" @click="handleNotificationClick(notification)">
          {{ notification.message }}
      </div>
    </li>

    <!-- v-if="notifications.length >= 10" /notifys/visits-->
    <li v-if="notifications.length > 0" class="text-center">
      <a class="notifications-list-link" :href="seeMoreLink" @click.prevent="showAllNotifications">{{ txtOptions.see_more }}</a>
      
    </li>
  </ul>
</template>
<script>
  export default {
    props: {
        notifications: {
            type: Array,
            required: true
        },
        txtOptions: {
         type: Object,
         required: true,
       },
       notificationType: { // Add notificationType prop
        type: String,
        default: 'all-notifications' 
      },
    },
    computed: {
        areAnyUnread(){
            /*It returns true if at least one notification has is_read set to false, indicating that there are unread notifications.*/
            return this.notifications.some(notification => !notification.is_read);
        },
        notificationMessage() {
          return this.notifications.length === 0 ? TXT_OPTIONS['nonew'] : '';
        },
        seeMoreLink() {
          // const baseUrl = '/notifys/'; // no need baseUrl
          const routeMap = {
            'VISIT': '/all-notif-visitors',
            'TEASE': '/all-notif-teasers',
            'general': '/all-notifications'
          };
          //console.log("Notification type:"+ this.notificationType)
          const type = this.notificationType || 'general'; 
          return routeMap[type];
        }
    },
    methods: {
        showAllNotifications(event) {
          event.preventDefault(); // Prevent default link behavior
          this.$emit('redirect', this.seeMoreLink); 
        },
        markAllRead(){
          if(this.areAnyUnread){
            // console.log("There are unread notifications.")
            this.$emit('mark-all-read');
          }else{
            console.log("All the notifications are already read.")
          }
        },
        handleNotificationClick(notification) {
          /* Only send the action if the notification is set to unread */
          if (!notification.is_read) {
            //console.log("The notification type is "+notification)
            this.$emit('mark-as-read', notification.id); // Emit an event to notify the parent component
          }
          //console.dir(notification);
          this.$emit('redirect', notification.redirect_url); 
        }
    },
  };
</script>
<style>
.notifications-list {
  width: 250px;
  max-width: 85vw;
  min-width: 180px;
  max-height: 80vh;
  overflow-y: auto;
  border-radius: 5px;
  margin-top:2px !important;
  box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.4);
}

.notifications-list li {
  margin-left: 0;
  margin-right: 0;
  padding: 0 1rem;
  cursor: pointer;
  border-top: 1px dashed #999;
}

.notifications-list .notifications-list-link {
  display: inline-block;
  width: 100%;
  color: var(--bs-primary);
}
.notifications-list .notifications-list-link:hover {
  color: #fff;
}
/*
._bold {
  font-weight: bold;
}
*/
._read {
  position: relative;
  padding-left: 20px;
}

._bold {
  padding-left: 20px;
}

._bold::before {
  content: "";
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
  width: 10px;
  height: 10px;
  background-color: #024ab5;
  border-radius: 50%;
}

</style>
